import { Seo } from '../components/Seo';

export function ShopPage() {
  return (
    <section className="stack-md">
      <Seo title="타로맨스 | Shop" description="타로맨스 바/샵 안내" />
      <article className="card">
        <h1>SHOP</h1>
        <p>타로맨스 시그니처 칵테일과 매장 메뉴를 안내합니다.</p>
        <p>상세 품목과 가격은 MENU 페이지에서 확인하실 수 있습니다.</p>
      </article>
    </section>
  );
}
